import React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Warning } from "license/LicenseCheck";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
const Description = styled.div`
  max-width: 700px;
`;
const ErrorList = styled.ul`
  padding: 0;
`;
const Row = styled.div`
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const SpinnerContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledIcon = styled(Icon)`
  margin: 3px 15px 0 0;
`;
const StyledWarning = styled(Warning)`
  padding: 0;
`;
const InvalidLicenseWidgetInfo = ({ featureName, withoutIcon = false }) => {
  const { data, isInitialLoading: isLoading } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  if (isLoading) return null;
  if (data.valid) return null;
  return /* @__PURE__ */ React.createElement(SpinnerContainer, null, !withoutIcon && /* @__PURE__ */ React.createElement(StyledIcon, { name: "enterprise", size: "3x" }), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("strong", null, "No valid license found")), /* @__PURE__ */ React.createElement(ErrorList, null, /* @__PURE__ */ React.createElement(StyledWarning, { featureName }))));
};
export default InvalidLicenseWidgetInfo;
